import { CSSProperties, ImgHTMLAttributes, useEffect, useState } from 'react';
import FallbackImg from 'assets/images/FallbackImg.svg';
import { Image } from 'antd';
import { ReactComponent as RemoveImg } from 'assets/icons/x-circle-fill.svg';

interface Props extends ImgHTMLAttributes<any> {
    fallback?: string;
    parentStyle?: CSSProperties;
    parentClassName?: string;
    preview?: boolean;
    clickRemove?: () => void;
}

export const ImageComponent = ({
    fallback,
    parentClassName,
    preview = false,
    src,
    parentStyle,
    clickRemove,
    ...props
}: Props) => {
    const [imgSrc, setImgSrc] = useState<string | undefined>(src ?? fallback ?? FallbackImg);
    const [imgFallback, setImgFallback] = useState<string | undefined>(fallback ?? FallbackImg);

    useEffect(() => {
        const imageFallback = fallback ?? FallbackImg;
        setImgSrc(src ?? imageFallback);
        setImgFallback(imageFallback);
    }, [src, fallback]);

    const classNames = [
        'flex items-center bg-white',
        clickRemove ? 'delete-image' : '',
        parentClassName ?? '',
    ].join(' ').trim();

    return (
        <div
            id="image-component"
            className={classNames}
            style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', ...parentStyle }}
        >
            {clickRemove && (
                <div className="remove-icon">
                    <RemoveImg
                        onClick={(e) => {
                            e.stopPropagation();
                            e.preventDefault();
                            clickRemove();
                        }}
                        fill="red"
                    />
                </div>
            )}
            
            <Image 
                style={{ objectFit: "contain", width: '100%'}} 
                {...props} 
                preview={false} 
                src={imgSrc} 
                fallback={imgFallback} 
            />
        </div>
    );
};
